import { OFFER_PREVIEW_HISTORY_ENTRY } from '../../constants/offerPreview';
import { TFeature } from '../../types/map';
import { TThunkAction } from '../../types/redux';
import { hasModalHistoryEntry, openModalHistoryEntry, waitModalHistoryBack } from '../../utils/modalHistory';
import { closeOfferPreview } from '../closeOfferPreview/closeOfferPreview';
import { loadPreviewOffers } from '../previewOffers/loadPreviewOffers';
import { setMapOffer } from '../setMapOffer/setMapOffer';
import { markAsViewed } from '../viewed/markAsViewed';

export interface IOpenOfferPreviewDeps {
  isDetailed: boolean;
  /** Превью с записью в history - только на телефоне */
  isPhone: boolean;
  precision: number;
}

export function openOfferPreview(
  feature: TFeature,
  { isDetailed, isPhone, precision }: IOpenOfferPreviewDeps,
): TThunkAction<Promise<void>> {
  return async (dispatch, _getState, context) => {
    const [offer] = feature.properties.offers;

    if (!offer?.realtyId) {
      context.logger.error('Не найден realtyId для открытия preview объявления', {
        domain: 'actions/features/openOfferPreview',
        featureId: feature.id,
      });

      return;
    }

    // popstate незавершённого шага назад закроет прежнее превью: ждём, чтобы он не попал на новое
    await waitModalHistoryBack();
    dispatch(setMapOffer({ realtyId: offer.realtyId, feature: { ...feature, precision } }));

    // Превью на телефоне: его «назад» закрывает превью; смена пина при открытом превью - запись та же
    if (isPhone && !hasModalHistoryEntry(OFFER_PREVIEW_HISTORY_ENTRY)) {
      openModalHistoryEntry(OFFER_PREVIEW_HISTORY_ENTRY, () => dispatch(closeOfferPreview()));
    }

    // Не ждём: превью покажет загрузку по своему статусу, ошибку loadPreviewOffers обработает сам.
    dispatch(loadPreviewOffers(feature.properties.offers.map(({ realtyId }) => realtyId)));

    if (!offer.isViewed && offer.cianId) {
      await dispatch(markAsViewed({ feature, offerId: offer.cianId, precision, isDetailed }));
    }
  };
}
